export default __webpack_public_path__ + "static/img/homepage-bg.0eb7edb.jpg";